import React from 'react';

import { InstructionContent } from './InstructionContent';

const PL: React.FC = () => (
  <div>
    <p className="mb-2">
      Profile miesięczne są oznaczane następującymi kolorami w podziale na
      statusy (również w pliku eksportu XLSX):
    </p>
    <ul className="mb-3">
      <li>
        <span className="badge bg-danger bg-opacity-75 me-1">czerwony</span> –
        Cofnięty
      </li>
      <li>
        <span className="badge bg-warning text-dark me-1">pomarańczowy</span> –
        Gotowy do fakturowania bez potwierdzonej dokumentacji
      </li>
      <li>
        <span className="badge bg-success bg-opacity-75 me-1">zielony</span> –
        Gotowy do fakturowania z potwierdzoną dokumentacją
      </li>
      <li>
        <span className="badge bg-primary bg-opacity-75 me-1">niebieski</span> –
        Zafakturowany
      </li>
    </ul>
    <p className="mb-2">
      <strong>Status ma potwierdzenie w dokumentacji</strong> – wartość{' '}
      <em>Tak</em> ustawiana jest:
    </p>
    <ul className="mb-0">
      <li>
        gdy dodane są dokumenty (załączniki) w kampanii o typach:{' '}
        <strong>IS</strong> – Inny dokument (sprzedaż), <strong>MPP</strong> –
        Podpisany mediaplan, <strong>PB</strong> – Rozliczenie/postbuy,{' '}
        <strong>PO</strong> – Dokument klienta, które są jednocześnie przypisane
        do wyświetlanego profilu miesięcznego,
      </li>
      <li>
        dla kampanii wewnętrznych – na podstawie zaakceptowanej realizacji
        zamówienia dla danego miesiąca. Realizacje niezaakceptowane, usunięte
        lub odrzucone są pomijane przy wyznaczaniu znacznika.
      </li>
    </ul>
  </div>
);

const EN: React.FC = () => (
  <div>
    <p className="mb-2">
      Monthly profiles are colour-coded by status (also in the XLSX export):
    </p>
    <ul className="mb-3">
      <li>
        <span className="badge bg-danger bg-opacity-75 me-1">red</span> –
        Reverted
      </li>
      <li>
        <span className="badge bg-warning text-dark me-1">orange</span> – Ready
        to invoice, documentation not confirmed
      </li>
      <li>
        <span className="badge bg-success bg-opacity-75 me-1">green</span> –
        Ready to invoice, documentation confirmed
      </li>
      <li>
        <span className="badge bg-primary bg-opacity-75 me-1">blue</span> –
        Invoiced
      </li>
    </ul>
    <p className="mb-2">
      <strong>Documentation confirmed</strong> – value <em>Yes</em> is set:
    </p>
    <ul className="mb-0">
      <li>
        when documents (attachments) of types <strong>IS</strong> – Other sales
        document, <strong>MPP</strong> – Signed media plan, <strong>PB</strong>{' '}
        – Post-buy, <strong>PO</strong> – Client document are added to the
        campaign and assigned to the displayed monthly profile,
      </li>
      <li>
        for internal campaigns – based on an accepted order fulfilment for the
        given month. Unaccepted, deleted or rejected fulfilments are ignored.
      </li>
    </ul>
  </div>
);

export const SalesInvoicingInfo: React.FC = () => (
  <InstructionContent pl={<PL />} en={<EN />} />
);
